const BASE_NAME = "player/playSource";

export const ACTION_TYPES = {
  SET_PLAY_SOURCE: `${BASE_NAME}/SET_PLAY_SOURCE`
};

export const setPlaySource = (playSource) => ({
  type: ACTION_TYPES.SET_PLAY_SOURCE,
  payload: playSource
});
